module.exports = __webpack_public_path__ + "img/search-icon.3077b81a.svg";